import React, { useState } from "react";

import { SlCallOut } from "react-icons/sl";
import { TerminateSessions, useSIP } from "../../hooks/calls/useSIP";
import { useSelector } from "react-redux";

import useTimer from "../../hooks/timer/useTimer";
import { formatPhoneNumber } from "../../utils/sipUtilsFunc";
import { PiPhoneCall, PiPhoneTransferFill } from "react-icons/pi";
import { CallDirection } from "../../constants/SIPEnums";
import { FcCallTransfer } from "react-icons/fc";

import { FaRegCirclePause } from "react-icons/fa6";
import { BsFillMicMuteFill } from "react-icons/bs";
import { IoMdKeypad } from "react-icons/io";
import { MdCallEnd } from "react-icons/md";
import DialPad from "./DialPad";

const OngoingScreen = () => {
  const [holdCall, setholdCall] = useState(false);
  const [muteCall, setMuteCall] = useState(false);
  const [DialPadMode, setDialPadMode] = useState(false);
  const [dialNumber, setDialNumber] = useState("");

  const userInfo = useSelector((state) => state.userInfo.user);

  const { toggleMuteUnmuteCall, toggelHoldCall, sendDTMF, blindTx, dialCall } = useSIP();
  const { hours, minutes, seconds } = useTimer();
  const { sessions } = useSelector((state) => state.SIPCalls);

  const endCallHandler = (session) => {
    // endCall();
    TerminateSessions(session, CallDirection.Outbound);
  };

  const holdUnholdHandler = () => {
    toggelHoldCall(!holdCall);
    setholdCall(!holdCall);
  };

  const muteUnmuteHandler = () => {
    toggleMuteUnmuteCall(!muteCall);
    setMuteCall(!muteCall);
  };

  const toggleDialPad = (mode) => {
    if (mode === DialPadMode) setDialPadMode("");
    else setDialPadMode(mode);
  };

  return (
    <>
      {Object.keys(sessions)?.map((sessionId) => {
        const session = sessions[sessionId];
        const number = session?.remoteIdentity?.uri?.user;

        return (
          <div key={sessionId}>
            {/* <div>
              {!DialPadMode && (
                <div className="text-center">
                  <FaUser size={50} />
                </div>
              )}
              <div className="text-center">
                <h3>{formatPhoneNumber(number)}</h3>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <p>{`${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}</p>
            </div> */}

            <div className="callBox">
              <span className="icon">
                <PiPhoneCall />
              </span>
              <p className="number mt-3 mb-2">{formatPhoneNumber(number)}</p>
              <p className="callTime">{`${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}</p>
            </div>

            {/* <div className="d-flex justify-content-center">
              <button
                className="btn btn-danger rounded-circle dial-btn"
                onClick={() => endCallHandler(session)}
              >
                <ImPhoneHangUp />
              </button>
              <button
                className={`btn btn-${
                  DialPadMode === "DTMF" ? "dark" : "light"
                } rounded-circle dial-btn`}
                onClick={() => toggleDialPad("DTMF")}
              >
                <MdDialpad />
              </button>
              <button
                className={`btn btn-${holdCall ? "dark" : "light"} rounded-circle dial-btn`}
                onClick={() => holdUnholdHandler()}
              >
                <FaRegPauseCircle />
              </button>
              <button
                className={`btn btn-${muteCall ? "dark" : "light"} rounded-circle dial-btn`}
                onClick={() => muteUnmuteHandler()}
              >
                {muteCall ? <BsMicMuteFill /> : <BsMicFill />}
              </button>
              <button
                className={`btn btn-${
                  DialPadMode === "CALLTRANSFER" ? "dark" : "light"
                } rounded-circle dial-btn`}
                onClick={() => toggleDialPad("CALLTRANSFER")}
              >
                <PiPhoneTransferFill />
              </button>
            </div> */}

            <button
              className="callTransfer my-5"
              onClick={() => toggleDialPad("CALLTRANSFER")}
              disabled={userInfo?.is_demo_account}
            >
              <SlCallOut /> Transfer Call
            </button>

            <div className="callRunSec">
              {DialPadMode === "DTMF" && (
                <DialPad
                  sendDTMF={sendDTMF}
                  dialNumber={dialNumber}
                  setDialNumber={setDialNumber}
                />
              )}

              {DialPadMode === "CALLTRANSFER" && (
                <>
                  <DialPad dialNumber={dialNumber} setDialNumber={setDialNumber} />
                  <div className="iconOpt mb-3">
                    <button
                      className={`icon ${holdCall ? "dark" : "light"}`}
                      onClick={() => blindTx(dialNumber)}
                      title="Transfer call"
                    >
                      <PiPhoneTransferFill />
                      <p>Transfer</p>
                    </button>
                    <button
                      className={`icon ${muteCall ? "dark" : "light"}`}
                      onClick={() => dialCall(dialNumber)}
                      title="Add to call"
                    >
                      <FcCallTransfer />
                      <p>Add</p>
                    </button>
                  </div>
                </>
              )}

              <div className="iconOpt mb-3">
                <button
                  className={`icon ${holdCall ? "on" : "off"}`}
                  onClick={() => holdUnholdHandler()}
                >
                  <FaRegCirclePause />
                  <p>Hold</p>
                </button>
                <button
                  className={`icon ${muteCall ? "on" : "off"}`}
                  onClick={() => muteUnmuteHandler()}
                >
                  <BsFillMicMuteFill />
                  <p>Mute</p>
                </button>
                <button
                  className={`icon ${DialPadMode === "DTMF" ? "on" : "off"}`}
                  onClick={() => toggleDialPad("DTMF")}
                >
                  <IoMdKeypad />
                  <p>Keypad</p>
                </button>
              </div>
              <button className="callEndIcon btn" onClick={() => endCallHandler(session)}>
                <MdCallEnd />
              </button>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default OngoingScreen;
